import { styled } from "styled-components";
const DateInputImpl = styled("div")({
  borderRadius: 2,
  boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
  outline: 0,
  width: "min-content"
});
export {
  DateInputImpl
};
